import React from 'react';
import blogData from './blogData';
import { Link } from 'react-router-dom';

interface BlogCardProps {
  limit?: number; // Optional prop to limit number of blogs
}

const BlogCard: React.FC<BlogCardProps> = ({ limit }) => {
  const blogsToShow = limit ? blogData.slice(0, limit) : blogData;

  return (
    <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 py-12">
      {/* Section Heading */}
      <div className="text-center mb-12">
        <span className="bg-[#e0f8de] text-[#0a6c67] text-xs font-semibold py-1 px-4 rounded-full mb-4">Read Our Latest Blogs</span>
        <h1 className="text-4xl font-bold text-gray-900 mt-3">Our Blogs</h1>
      </div>

      {/* Blog Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-8">
        {blogsToShow.map((blog) => (
          <Link to={`/blogs/${blog.id}`} key={blog.id} className="group flex-col gap-4 bg-white shadow-md overflow-hidden">
            <div className="w-100 h-[200px] rounded-md overflow-hidden">
              <img src={blog.image} alt={blog.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-4 w-100">
              <h3 className="text-lg font-semibold mb-2 group-hover:text-orange-600 transition line-clamp-2">
                {blog.title}
              </h3>
              <p className="text-sm text-[#15b315] mb-0">
                Published by: Minterminds
              </p>
              <p className='text-muted text-sm mb-2'>{blog.publishedDate}</p>
              <p className="text-sm text-[#696363] line-clamp-3">{blog.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogCard;
